// src/client/pages/LoginClient.jsx
import React, { useState } from 'react';
import { useAuthClient } from '../../core/context/AuthClientContext';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../core/api'; // ← utilise ton axios configuré

const LoginClient = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const { login } = useAuthClient();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      // 🔑 Récupère la clé client
      const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

      // 🔐 Appel API avec clientKey
      const res = await api.post('/api/users/login', formData, {
        headers: { 'x-client-key': clientKey },
      });

      const { token, user } = res.data;

      // 🧠 Stockage via contexte
      login(token, user);

      console.log('✅ Connexion réussie', { user, token });
      navigate('/account');
    } catch (err) {
      console.error('❌ Erreur connexion client :', err.response?.data || err.message);
      setMessage('❌ Identifiants invalides ou problème serveur.');
    }
  };

  return (
    <div className="auth-container">
      <h2>Connexion client</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Adresse email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Mot de passe"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button type="submit">Se connecter</button>
      </form>

      {message && <p className="auth-message">{message}</p>}

      <p className="auth-link">
        Pas encore de compte ? <Link to="/register">Créer un compte</Link>
      </p>
    </div>
  );
};

export default LoginClient;
